import RcSlider, { SliderProps as RcSliderProps } from 'rc-slider'
import { FC } from 'react'

import { MaxValue, MinValue, SliderContainer } from './styled'

type ExtraProps = {
  valueFormat?: (value: number) => number | string
  unboundMaxLabel?: boolean
}

export type SliderProps = RcSliderProps & ExtraProps

/**
 * @description Provides basic Slider component. See https://slider-react-component.vercel.app/#api for list of options.
 *
 * @param valueFormat - custom formatter for values, e.g. to make a price range ($0 - $100)
 * @param unboundMaxLabel - adds '+' at the end of Max label
 */

export const SLIDER_DEFAULT_MIN = 0
export const SLIDER_DEFAULT_MAX = 100

export const Slider: FC<SliderProps> = ({
  valueFormat,
  unboundMaxLabel = false,
  min = SLIDER_DEFAULT_MIN,
  max = SLIDER_DEFAULT_MAX,
  ...props
}) => {
  const minValue = valueFormat ? valueFormat(min) : min
  const maxValue = valueFormat ? valueFormat(max) : max

  return (
    <SliderContainer>
      <MinValue>{minValue}</MinValue>
      <MaxValue>{`${maxValue}${unboundMaxLabel ? '+' : ''}`}</MaxValue>
      <RcSlider min={min} max={max} {...props} />
    </SliderContainer>
  )
}
